import {
	ChangeDetectionStrategy,
	Component,
	forwardRef,
	Input,
	SimpleChanges,
	ViewEncapsulation,
} from '@angular/core';
import { CommonControlComponent } from '../control/control.class';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
	selector: 'common-checkbox',
	templateUrl: './checkbox.component.pug',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ['./checkbox.component.sass'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CommonCheckboxComponent),
			multi: true,
		},
	],
	encapsulation: ViewEncapsulation.None,
})
export class CommonCheckboxComponent extends CommonControlComponent<boolean> {
	@Input() label: string; // Labels text (text)
	@Input() htmlLabel: string; // Labels text (HTML)
	@Input() labelClasses: string; // CSS classes for label
	@Input() checkboxId: string; // Id for linkng with label
	@Input() indeterminate: boolean; // Indeterminate view mode
	@Input() isDescriptionShow: boolean; // Showing description
	@Input() descriptionValue: string; // Description text
	@Input() color: string; // Color in hex format
	@Input() isDraggable: boolean = false;
	@Input() hideTitle: boolean = false; // Parameter hides the tooltip with label
	@Input() reversTitleOrder: boolean = false; // Parameter change orders for title with descriptionField


	idKey = 'checkbox_';
	isIndeterminate = false;

	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);

		this.checkIndeterminate();
	}

	// With zonejs
	onChangeCheckbox(value: boolean) {
		const oldValue = this.model;
		this.model = value;

		if (oldValue !== value) {
			this.checkIndeterminate();
			this.modelChange.emit(value);
			this.emitOnChange(value);
		}
	}

	private checkIndeterminate() {
		this.isIndeterminate = !this.model && !!this.indeterminate;
	}
}
